import { __rest, __assign } from 'tslib';
import React, { useMemo } from 'react';
import cn from 'classnames';
import { THeadCell } from '../thead-cell/Component.js';
import { SortIconAsc } from './sort-icon-asc.js';
import { SortIconDesc } from './sort-icon-desc.js';
import { SortIconUnset } from './sort-icon-unset.js';
import '../table-context/index.js';

var styles = {"content":"table__content_rr211","icon":"table__icon_rr211","reverse":"table__reverse_rr211","sorted":"table__sorted_rr211"};
require('./index.css');

var TSortableHeadCell = function (_a) {
    var _b, _c;
    var children = _a.children, className = _a.className, defaultIsSortedDesc = _a.defaultIsSortedDesc, isSortedDesc = _a.isSortedDesc, textAlign = _a.textAlign, onSort = _a.onSort, restProps = __rest(_a, ["children", "className", "defaultIsSortedDesc", "isSortedDesc", "textAlign", "onSort"]);
    var SortIcon = useMemo(function () {
        var value = isSortedDesc;
        if (value === undefined)
            value = defaultIsSortedDesc;
        if (typeof value === 'boolean')
            return value ? SortIconDesc : SortIconAsc;
        return SortIconUnset;
    }, [defaultIsSortedDesc, isSortedDesc]);
    return (React.createElement(THeadCell, __assign({ className: className }, restProps),
        React.createElement("div", { className: cn(styles.content, (_b = {}, _b[styles.reverse] = textAlign === 'right', _b)) },
            children,
            React.createElement(SortIcon, { onClick: onSort, className: cn(styles.icon, (_c = {},
                    _c[styles.sorted] = isSortedDesc !== undefined,
                    _c)) }))));
};

export { TSortableHeadCell };
